import React from 'react';

/**
 * Composant DropdownMenu réutilisable
 * @param {Array} items - Array d'objets avec { icon: Component, label: string, onClick: function, separator: boolean }
 * @param {string} className - Classes CSS additionnelles
 * @param {string|number} width - Largeur du dropdown (ex: 'w-48', 'w-56', '200px', etc.)
 */
const DropdownMenu = ({ items = [], className = '', width = 'w-48' }) => {
  const widthClass = typeof width === 'number' ? `w-[${width}px]` : width;
  
  return (
    <div className={`bg-white rounded-lg shadow-lg border border-gray-100 py-2 p-1 z-[9999] ${widthClass} ${className}`}>
      {items.map((item, index) => {
        if (item.separator) {
          return <div key={`separator-${index}`} className="border-b border-gray-100 my-1" />;
        }
        
        return (
          <button
            key={index}
            onClick={item.onClick}
            className={`w-full px-4 py-2 text-left text-sm text-gray-700 rounded-md hover:bg-gray-100 active:bg-gray-200 flex items-center gap-2 transition-colors ${
              item.className || ''
            }`}
            disabled={item.disabled}
          >
            {item.icon && (
              <span className="shrink-0">
                {React.isValidElement(item.icon) 
                  ? item.icon
                  : React.createElement(item.icon, { wh: 18, color: item.iconColor || '#374151' })
                }
              </span>
            )}
            <span>{item.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default DropdownMenu;

